export default __webpack_public_path__ + "static/media/payment.402519f6.svg";